import {
	ArrowButtons,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	Gallery,
	GallerySlide,
	Image,
	Text,
	TokenTextAppearance,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import './WhatIsAVinModal.scss';
import { Modal } from '../../models/Modal';
import { NavigationImages } from '../../organisms/NavigationImages/navigation-images';

function WhatIsAVinModal({ close, state }: Modal<WhatIsAVinModalProps>) {
	const { baseUrl, trackingService, t } = state;
	const gallery = [`${baseUrl}/assets/startpage/fin_modal/fin_details_1.webp`, `${baseUrl}/assets/startpage/fin_modal/fin_details_2.webp`];

	const vinCheckTrackingLayerLoad = () => {
		if (trackingService) {
			trackingService.track('VWBasic_Layer_Load', {
				eventInfo: {
					eventAction: 'VWBasic_Layer_Load',
					pageId: window.location.href,
					pageName: 'Start Page',
					contentId: 'startPage.whatIsAVin',
					sectionName: 'whatIsAVin',
					brand: 'passenger',
				},
				user: {
					browserResolutionHeight: window.innerHeight,
					browserResolutionWidth: window.innerWidth,
					browserResolutionOrientation: window.innerHeight >= window.innerWidth ? 'v' : 'h',
				},
				personalization: {
					personalizable: false,
				},
			});
		}
	};

	vinCheckTrackingLayerLoad();

	return (
		<ThemeProvider theme="main">
			<Container wrap="always" gutter={ContainerGutter.dynamic0100} padding={{ left: ContainerPadding.grid002, right: ContainerPadding.grid002 }}>
				<Text appearance={TokenTextAppearance.headline500}>{t('whatIsAVin.title')}</Text>

				<div className="gallery-size">
					<Gallery
						id="what-is-a-vin"
						bottomElements={
							<>
								<ArrowButtons buttonPreviousAriaLabel="To previous slide" buttonNextAriaLabel="To next slide" />
								<NavigationImages>
									{gallery.map((image) => (
										<Image className="nav-image" key={image} src={image} alt="Info Image" />
									))}
								</NavigationImages>
							</>
						}
						ariaLabel="What is a Vin Gallery"
					>
						{gallery.map((image) => (
							<GallerySlide ariaLabel="currentImage" key={image}>
								<Image src={image} alt="Info Image" />
							</GallerySlide>
						))}
					</Gallery>
				</div>

				<Text appearance={TokenTextAppearance.headline100}>{t('whatIsAVin.paragraph1')}</Text>

				<CTA tag="button" emphasis="secondary" onClick={close}>
					{t('general.close')}
				</CTA>
			</Container>
		</ThemeProvider>
	);
}

export interface WhatIsAVinModalProps {
	baseUrl: string;
	trackingService: any;
	t: any;
}

export default WhatIsAVinModal;
